import React from "react"

import { ShimmerCategoryItem } from "react-shimmer-effects"

const ShopListShimmer = (props) => {
  const { t } = props

  return (
    <div className="shopListViewContainer">
      <div className="shopItem">
        <ShimmerCategoryItem />
      </div>

      <div className="shopItem">
        <ShimmerCategoryItem />
      </div>

      <div className="shopItem">
        <ShimmerCategoryItem />
      </div>
    </div>
  )
}

export default ShopListShimmer
